















import {Component, Vue} from 'vue-property-decorator';
import {i18n} from '../plugin/i18n';
import ButtonMagnetic from '../components/ButtonMagnetic.vue';
import ButtonNextPage from '../components/ButtonNextPage.vue';
import PointOfView from '../components/PointOfView.vue';
import {Meta} from '../decorators/decorators';

@Component({
	components: {PointOfView, ButtonNextPage, ButtonMagnetic},
})
export default class EditoFR extends Vue {
	title: String = i18n.t('EditoFR.title') as string;
	subTitleMC: String = i18n.t('EditoFR.subTitleMC') as string;

	@Meta
	myMetaConfig() {
		return {
			title: i18n.t('EditoFR.title')
		}
	}
}
